import React, {
  ReactNode,
  createContext,
  useContext,
  useState,
  Dispatch,
  SetStateAction,
} from "react";

interface Filters {
  // f1
  format?: string;
  channel?: string;
  channel_type?: string;
  region?: string;
  state?: string;
  dc?: string;
  // f2
  family?: string;
  brand?: string;
  category?: string;
  store?: string;
  sd?: string;
  article?: string;
}

interface FilterValueContextProps {
  filtersValue: Filters;
  setFiltersValue: Dispatch<SetStateAction<Filters>>;
}

const FilterValueContext = createContext<FilterValueContextProps | undefined>(
  undefined
);

interface FilterProviderProps {
  children: ReactNode;
}

export const FilterValueProvider: React.FC<FilterProviderProps> = ({
  children,
}) => {
  const [filtersValue, setFiltersValue] = useState<Filters>({});

  return (
    <FilterValueContext.Provider value={{ filtersValue, setFiltersValue }}>
      {children}
    </FilterValueContext.Provider>
  );
};

export const useFilterValueContext = (): FilterValueContextProps => {
  const context = useContext(FilterValueContext);
  if (!context) {
    throw new Error(
      "useFilterValueContext must be used within a FilterValueProvider"
    );
  }
  return context;
};
